import React, { useEffect } from "react";
import Heading from "../Components/Heading";
import Message from "../Components/Messages";
import { BRAND } from "../config/brand";

function PrivacyAndPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main-policy">
      <Heading heading="Privacy Policy" />
      <div className="policy-content">
        <Message
          msg="1. Introduction"
          desc={`At ${BRAND.name}, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard any data you provide when using our website or engaging with our services. By accessing our platform, you consent to the practices described in this policy.`}
        />
        <Message
          msg="2. Information we collect"
          desc={`When you engage with ${BRAND.name}, we may collect personal details such as your name, email address, and any information you provide through contact forms or inquiries. Additionally, we gather technical data, including your device type, browser, and IP address, to enhance your user experience and maintain security. Our website may also use cookies and tracking technologies to analyze usage patterns and improve functionality.`}
        />
        <Message
          msg="3. How we use your information"
          desc="The information we collect is used to provide a seamless experience, improve our platform, and ensure compliance with regulatory standards. Your data helps us respond to inquiries, enhance security measures, and optimize our services. We do not sell or trade personal information, and any data shared with third-party service providers is strictly for security monitoring, analytics, or technical support purposes"
        />
        <Message
          msg="4. Data security and protection"
          desc={`${BRAND.name} implements industry-standard encryption and access controls to safeguard your data from unauthorized access or misuse. We continuously monitor our systems to maintain a secure environment for all users. While we take every measure to protect your information, we encourage users to practice safe browsing and remain vigilant when sharing personal data online.`}
        />
        <Message
          msg="5. Your rights and choices"
          desc={`As a user, you have the right to access, correct, or request the deletion of your personal information. You can also manage cookie preferences and opt out of specific data processing activities where applicable. If you have any concerns regarding your privacy or wish to make a request, you may contact us at ${BRAND.contactEmail}`}
        />
        <Message
          msg="6. Changes to this policy"
          desc="We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any modifications will be posted on this page, and we encourage users to review the policy regularly to stay informed about how their data is managed."
        />
      </div>
    </div>
  );
}

export default PrivacyAndPolicy;
